import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../base/base-mutation';
import { Rule } from '../base/mutation-rules';
import { SHAPE_DATA_TYPES } from '../../data';
import { invert } from '../../utils/protoutil';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidTransformShapeMutationData } from '../base/valid-mutation-data';

export class TransformShapeMutation extends BaseMutation<PresentationDataModel, IValidTransformShapeMutationData> {
    public readonly type: MutationType = MutationType.TransformShape;

    public apply(presentation: PresentationDataModel) {
        const { shapeId, clearXfrm, xfrmDelta, chXfrmDelta } = this.data;
        const shape = presentation.store.models.get(shapeId, ...SHAPE_DATA_TYPES);
        assert(shape);

        shape.store.patchData({
            spPr: {
                xfrm: clearXfrm
                    ? null
                    : {
                          ...xfrmDelta,
                          ...chXfrmDelta,
                      },
            },
        });
    }

    public invert(presentation: PresentationDataModel): [IValidTransformShapeMutationData] {
        const { pageId, shapeId, parentId, shapeType, clearXfrm, xfrmDelta, chXfrmDelta } = this.data;

        const shape = presentation.store.models.get(shapeId, ...SHAPE_DATA_TYPES);
        assert(shape);

        const xfrm = shape.store.data.spPr?.xfrm;
        const transformShape = {
            type: MutationType.TransformShape,
            pageId,
            shapeId,
            parentId,
            shapeType,
        };

        if (clearXfrm) {
            return [
                {
                    ...transformShape,
                    xfrmDelta: xfrm,
                },
            ];
        }

        return [
            {
                ...transformShape,
                clearXfrm: !xfrm,
                xfrmDelta: xfrm && xfrmDelta ? invert(xfrm, xfrmDelta) : undefined,
                chXfrmDelta: xfrm && chXfrmDelta ? invert(xfrm, chXfrmDelta) : undefined,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId } = this.data;
        return Rule.shape.should.existInPage(presentation, shapeId, pageId);
    }
}
